import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import InputField from 'Components/Input/InputField';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import { ptBR } from 'date-fns/locale';
import './SalaryPanel.css'
import ReactDatePicker from 'react-datepicker';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import useUpdateEffect from 'Components/UseUpdateEffect/useUpdateEffect';

const SalaryPanel = ({
    usersSelected
}) => {
    const [idSalary, setIdSalary] = useState(null)
    const [salary, setSalary] = useState(null)
    const [fgts, setFgts] = useState(null)
    const [inss, setInss] = useState(null)
    const [thirteenthSalary, setThirteenthSalary] = useState(null)
    const [vacation, setVacation] = useState(null)
    const [oneHalfVacation, setOneHalfVacation] = useState(null)
    const [updateDate, setUpdateDate] = useState(null)
    const [username, setUsername] = useState(null)
    const [isChangeCostDay, setIsChangeCostDay] = useState('N')
    const [dtStartSalary, setDtStartSalary] = useState(null)
    const [dtFinishSalary, setDtFinishSalary] = useState(null)
    const [isRealValue, setIsRealValue] = useState('N')
    const [isAutomaticCalculation, setIsAutomaticCalculation] = useState('N')

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [salaryPanelList, setSalaryPanelList] = useState(null);

    const [loadingSalaryPanel, setLoadingSalaryPanel] = useState(null);

    const messageIsChangeCostDay = () => {
        if (inserting) {
            return ('Inserir orçamento detalhado')
        } else {
            return ('Atualizar orçamento detalhado')
        }
    }

    const attributeList = [
        { name: "id", value: idSalary, setter: setIdSalary },
        { name: "salary", value: salary, setter: setSalary },
        { name: "fgts", value: fgts, setter: setFgts, isVisible: isAutomaticCalculation === 'S' },
        { name: "inss", value: inss, setter: setInss, isVisible: isAutomaticCalculation === 'S' },
        { name: "thirteenthSalary", value: thirteenthSalary, setter: setThirteenthSalary, isVisible: isAutomaticCalculation === 'S' },
        { name: "oneHalfVacation", value: oneHalfVacation, setter: setOneHalfVacation, isVisible: isAutomaticCalculation === 'S' },
        { name: "inss", value: inss, setter: setInss, isVisible: isAutomaticCalculation === 'S' },
        { name: "vacation", value: vacation, setter: setVacation, isVisible: isAutomaticCalculation === 'S' },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
        { name: "username", value: username, setter: setUsername },
        {
            name: "isAddAnnualBudget",
            value: isChangeCostDay,
            setter: setIsChangeCostDay,
            customMessage: messageIsChangeCostDay()
        },
        { name: "dtStart", value: dtStartSalary, setter: onUpdatedtStartSalary, isVisible: isChangeCostDay === 'S', isMandatory: (isChangeCostDay === 'S' ? 'S' : 'N') },
        { name: "dtFinish", value: dtFinishSalary, setter: setDtFinishSalary, isVisible: isChangeCostDay === 'S', isMandatory: (isChangeCostDay === 'S' ? 'S' : 'N') },
        {
            name: "isRealValue",
            value: isRealValue,
            setter: setIsRealValue
        },
        {
            name: "isAutomaticCalculation",
            value: isAutomaticCalculation,
            setter: setIsAutomaticCalculation
        }
    ];

    const fetchDataSalaryPanel = async (userId) => {
        const parameters = { userId: userId }
        const salary = await ExecuteAxios.api('get', `/salary/salary-by-user-id/`, { params: parameters })
        if (salary) {
            setSalaryPanelList(salary)
            ApplyAttributes.applyAttributes(salary, attributeList)
        }

        if (!userId || userId.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (isChangeCostDay !== 'S') {
            setDtStartSalary(null)
            setDtFinishSalary(null)
        }
    }, [isChangeCostDay]);

    useEffect(() => {
        setUpdating(false)
        setInserting(false)
        if (usersSelected.length === 1) {
            fetchDataSalaryPanel(usersSelected[0])
        } else {
            fetchDataSalaryPanel(null)
        }
    }, [usersSelected]);

    // A carga inicial é feita pelo efeito de usersSelected; aqui só ao entrar/sair da edição
    useUpdateEffect(() => {
        if (usersSelected.length === 1) {
            fetchDataSalaryPanel(usersSelected[0])
        }
    }, [inserting, updating]);

    function onUpdatedtStartSalary(date) {
        setDtStartSalary(date)
    }

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    async function postSalary() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingSalaryPanel(true)
                return await ExecuteAxios.api('post', `/salary/`, {
                    salary: salary,
                    userId: usersSelected[0],
                    isAddAnnualBudget: isChangeCostDay,
                    dtStartSalary: dtStartSalary,
                    dtFinishSalary: dtFinishSalary,
                    isRealValue: isRealValue,
                    isAutomaticCalculation: isAutomaticCalculation
                });
            } finally {
                setLoadingSalaryPanel(false)
            }
        }
    }

    async function putSalary() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingSalaryPanel(true)
                return await ExecuteAxios.api('put', `/salary/`, {
                    id: idSalary,
                    salary: salary,
                    userId: usersSelected[0],
                    isAddAnnualBudget: isChangeCostDay,
                    dtStartSalary: dtStartSalary,
                    dtFinishSalary: dtFinishSalary,
                    isRealValue: isRealValue,
                    isAutomaticCalculation: isAutomaticCalculation
                });
            } finally {
                setLoadingSalaryPanel(false)
            }
        }
    }


    const readOnlyAttributes = !(inserting || updating);
    return (
        <LoadingIndicator loaded={!loadingSalaryPanel}>
            <Panel
                style={userControlPanelStyle}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={idSalary}
                putFunction={putSalary}
                enableNewRecord={true}
                canNewRecord={!idSalary}
                postFunction={postSalary}
                canViewCRUD={true}
                readOnly={!(usersSelected && usersSelected.length === 1)}
                recordsSelected={usersSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={salaryPanelList}
                attributeList={attributeList}
            >
                <AutomaticallyListedAttributes
                    list={salaryPanelList}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            </Panel>
        </LoadingIndicator>
    );
};

export default SalaryPanel;


